/***
 * 参数设置
 *  */
// 定制逻辑处理
export default {
  // 是否展示自定义货物存放位置设置
  customized_storage_location_setting: ["99579", "90100"], // 202510211107491473782
}
